export const filterByKeyAndValue = (input: string, option: any) =>
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
  option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0

export const filterByValue = (input: string, option: any) =>
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

export const filterByTooltipValue = (input: string, option: any) =>
  option.props.children.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
